// extracted by mini-css-extract-plugin
export default {"custom-input":"CustomInput_custom-input__1ck0g"};